module.exports = __webpack_public_path__ + "static/media/Braintree.76a784c0.svg";